﻿import * as React from 'react';
import { useSvgEditService } from '../../services/svg-edit-service';
import { useColourService } from '../../services/colours-service';
import { usePanelService } from '../../services/panels-service';
import { SvgAnnotations } from './svg-annotations';

export const UpdateSvgInlineAnnotations = () => {
    for (const forceUpdate of forceUpdaters) {
        forceUpdate({});
    }
}

let forceUpdaters: React.Dispatch<any> [] = [];

export const SvgInlineAnnotations = () => {
    const [, forceUpdate] = React.useState<{}>({});
    const svgEditService = useSvgEditService(() => onSelectionChanged());

    // We don't actually care about these services, but we do care about their on-changed events.
    useColourService(() => onSelectionChanged());
    usePanelService(() => onSelectionChanged());

    React.useEffect(() => {
        forceUpdaters.push(forceUpdate);
        svgEditService.canvas.getRootElem().addEventListener("mousemove", e => SvgAnnotations.UpdateAnnotations(e.buttons == 0));

        // And when unloading
        return () => {
            forceUpdaters = forceUpdaters.filter((update) => update !== forceUpdate);
        };
    }, []);

    const onSelectionChanged = () => {
        SvgAnnotations.UpdateAnnotations();
    };

    const guideLineStroke = "rgba(136,136,136,0.8)";
    const bbox = SvgAnnotations.svgBBox;

    if (!bbox) {
        return <g></g>;
    }

    return (
        <>
            <defs>
                {SvgAnnotations.svgDefs.map((def, i) => <React.Fragment key={i}>{def}</React.Fragment>)}
            </defs>
            <g transform={`translate(${SvgAnnotations.OffsetX}, ${SvgAnnotations.OffsetY})`} pointerEvents="none">
                <line x1={-99999} y1={bbox.top} x2={99999} y2={bbox.top} strokeWidth={1} stroke={guideLineStroke} />
                <line x1={-99999} y1={bbox.bottom} x2={99999} y2={bbox.bottom} strokeWidth={1} stroke={guideLineStroke} />
                <line x1={bbox.left} y1={-99999} x2={bbox.left} y2={99999} strokeWidth={1} stroke={guideLineStroke} />
                <line x1={bbox.right} y1={-99999} x2={bbox.right} y2={99999} strokeWidth={1} stroke={guideLineStroke} />

                {SvgAnnotations.svgAnnotations.map((annot, i) => <React.Fragment key={i}>{annot}</React.Fragment>)}
            </g>
        </>
    );
}
